import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useAuthStore } from '@munawb/hooks';
import { supabase } from '@munawb/supabase';
import type { ProfileWithDept } from '@munawb/types';

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  const { setProfile, setLoading, setInitialized, isInitialized } = useAuthStore();

  // تحقق فوري من رابط استرداد كلمة المرور قبل أي شيء آخر
  // Supabase يضع type=recovery في الـ hash عند الضغط على رابط الاسترداد
  if (typeof window !== 'undefined' && window.location.hash.includes('type=recovery')) {
    window.location.replace('/reset-password/confirm' + window.location.hash);
    return null;
  }

  // تهيئة الجلسة مرة واحدة عند بداية التطبيق
  useEffect(() => {
    if (isInitialized) return;

    // اقرأ الـ profile من localStorage مباشرة بدون أي طلب شبكة
    // (نفس المنطق المستخدم في getProfileSync لكن هنا نحدث الـ store أيضاً)
    try {
      const stored = localStorage.getItem('munawb-profile');
      if (stored) {
        const profile = JSON.parse(stored) as ProfileWithDept;
        setProfile(profile);
      }
    } catch {
      // لا شيء — سيبقى profile فارغاً
    } finally {
      setLoading(false);
      setInitialized();
    }

    // استمع لأحداث تسجيل الخروج فقط عبر Supabase
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event) => {
        if (event === 'PASSWORD_RECOVERY') {
          window.location.href = '/reset-password/confirm';
          return;
        }
        if (event === 'SIGNED_OUT') {
          localStorage.removeItem('munawb-profile');
          setProfile(null);
        }
      }
    );

    return () => subscription.unsubscribe();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Outlet />;
}
